import { NoTranscription } from '@app/modules/fragments/screens/view/components/transcription/status/NoTranscription';
import { Spinner } from '@mi-front/ui';
import { Alert } from '@mui/material';
import { DateTime } from 'luxon';
import { FormattedMessage } from 'react-intl';
import { useFragmentQuery } from '../../../../hooks/useFragment';
import { TranscriptionStatus } from './TranscriptionStatus';

interface Props {
  fragmentId: string;
}

export function TranscriptionView({ fragmentId }: Props) {
  const query = useFragmentQuery(fragmentId);

  const fragment = query.data;

  if (!fragment) {
    return <Spinner />;
  }

  if (fragment.media.status !== 'READY') {
    return (
      <Alert severity={'info'}>
        <FormattedMessage
          id="fragments.transcription.waitingForMedia"
          defaultMessage="Esperando por generación de media del fragmento..."
        />
      </Alert>
    );
  }

  // Hotfix: treat fragment as "recently created" if < 5 min old to avoid showing NoTranscription
  // when the API returns fragment without transcription data yet (bad/delayed API response).
  const isRecentlyCreated =
    fragment.createdAt &&
    DateTime.fromISO(fragment.createdAt) > DateTime.now().minus({ minutes: 5 });

  if (!fragment.transcription && !isRecentlyCreated) {
    return <NoTranscription fragment={fragment} />;
  }

  return <TranscriptionStatus fragment={fragment}></TranscriptionStatus>;
}
